import BasicService from "../service/BasicService";

class OnlineshoppingService extends BasicService {
  constructor() {
    super();
  }

  getAllOnlineshopping(osType) {
    let url = "/os";
    return this.axios.get(url,{
      params:{
        osType
      }
    }).then(request => request.data);
  }
  getOsByExpiredDate() {
    let url = "/os/expiredDate";
    return this.axios.get(url).then(request => request.data);
  }
  getUserByOs() {
    let url = "/useraccounts/os";
    return this.axios.get(url).then(request => request.data);
  }
  getUserByDelivery() {
    let url = "/useraccounts/delivery";
    return this.axios.get(url).then(request => request.data);
  }
  getOnlineshoppingByTownship(townshipId) {
    let url = "/os/township";
    return this.axios.get(url,
      {
        params: {
          townshipId
        }
      }).then(request => request.data);
  }

  deleteOnlineshopping(onlineshopping) {
    let url = `/os/${onlineshopping.osId}`;
    return this.axios.delete(url, onlineshopping).then(request => request.data);
  }
  updateOnlineshopping(onlineshopping) {
    let url = `/os/${onlineshopping.osId}`;
    return this.axios.put(url, onlineshopping).then(request => request.data);
  }
  addOnlineshopping(onlineshopping) {
    let url = `/os`;
    return this.axios.post(url, onlineshopping).then(request => request.data);
  }
  getOsLocation(osId,latitude) {
    let url = `/os/location/${osId}`;
    return this.axios.get(url,{
      params:{
        latitude
      }
    }).then(request => request.data);
  }
}

const onlineshoppingService = new OnlineshoppingService();
export default onlineshoppingService;
